let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("ffQaD"), load("kvRbA"), load("krtxM")]).then(() => parcelRequire('875KN'));